<template>
  <div style="height: 100%;" class="knowledge-wrap">
    <Tabs @on-click="tabEvent" :animated="false" :value="country">
        <Button v-if="false" @click="addLangModal = true" style="position: absolute;top: 0px;right: 0px;" type="primary">添加语言</Button>
        <TabPane :key="index" v-for="(lang, index) in langList" :label="lang.name" :name="lang.country">
          <Input @on-enter="getQaList(1, false)" v-model="keyword">
              <Select slot="prepend" style="width: 80px">
                  <Option value="day">搜索内容</Option>
              </Select>
              <Button @click="getQaList(1, false)" slot="append" icon="ios-search"></Button>
          </Input>
          <Layout style="margin-top: 10px;">
          <Sider style="background: #fff!important;" width="240" hide-trigger>
            
            <Menu active-name="0">
              <Scroll :height="scrollHeight">
                <MenuItem @click.native="selectCate(null)" name="0">
                    全部分类
                    <Icon style="position: absolute;right: 0px;" color="#2e4fed" :size="25" @click="addCateModal = true" type="ios-add" />
                </MenuItem>
                 <MenuItem @mouseenter.native="hoverCate(index)" @mouseleave.native="hoveroutCate(index)" style="position: relative;" @click.native="selectCate(cate)" v-for="(cate, index) in cateList" :key="index" :name="index">
                     {{cate.name}}
                     <div v-show="cate.show == true" class="cate-tool">
                       <Icon style="cursor: pointer;" @click="editCate(cate)" :size="20" type="md-create" />
                       <Icon style="cursor: pointer;" @click="delCate(cate)" :size="20" type="ios-trash" />
                     </div>
                 </MenuItem>
              </Scroll>
            </Menu>
          </Sider>
          <Layout>
            <Content style="margin-left: 10px;">
              <div style="padding: 8px 0px;display: flex;align-items: center;justify-content: space-between;">
                <div>                
                  <Button @click="addModal = true" type="primary">添加FAQ</Button>
                  &nbsp;<Button @click="recordModal = true" type="primary">添加记录</Button>
                  
                </div>
                <div>                
                  <Page :current="curPage" :total="total" :page-size="pageSize" @on-change="switchPage" @on-page-size-change="switchPagesize" show-sizer />
                </div>
              </div>
              <Table :columns="columns" :data="data" :height="tableHeight">
                <template slot-scope="{ row }" slot="questions">
                    <div style="width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;color: #4663ed">{{ row.questions }}</div>
                </template>
                <template slot-scope="{ row }" slot="answers">
                    <div @click="row.textspread = !row.textspread" style="width: 100%;overflow: hidden;text-overflow: ellipsis;cursor: pointer;" :style="{'white-space': (row.textspread ? 'normal' : 'nowrap') }" >{{ row.answers_short.text }}</div>
                    <transition name="fade" v-if="row.answers_short.images.length > 0">
                      <span style="margin-right: 10px;" :key="i" v-for="(image, i) in row.answers_short.images"><img :preview="row.id" :preview-text="row.answers_short.text ? row.answers_short.text : ''" style="max-height: 50px;" :src="image.url"></span>
                    </transition>
                   
                </template>
                <template slot-scope="{ row }" slot="cate">
                    <div style="width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{ row.cate ? row.cate.name : '' }}</div>
                </template>
                <template slot-scope="{ row }" slot="user">
                    <div style="width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{ row.user ? row.user.username : '' }}</div>
                </template>
                <template slot-scope="{ row }" slot="action">
                    <Button @click="copyToChat(row)" type="primary" size="small" style="margin-right: 5px" >聊天</Button>
                    <Button @click="onCopy(row)" type="primary" size="small" style="margin-right: 5px" >复制</Button>
                    <Button @click="editKnow(row)" type="primary" size="small" style="margin-right: 5px" >编辑</Button>
                    <Button @click="topUp(row)" type="primary" size="small" style="margin-right: 5px" >{{row.weigh > 0 ? '取消置顶' : '置顶'}}</Button>
                    <Button @click="delKnow(row)" type="error" size="small" style="margin-right: 5px" >删除</Button>

                </template>
              </Table>
            </Content>
          </Layout>
          </Layout>

        </TabPane>
    </Tabs>

    <Modal 
        v-model="addModal"
        title="添加"
        width="500"
        @on-ok="addKnowledge()"
        >
        <Form :model="formItem" :label-width="80">
          <FormItem label="分类">
            <Select v-model="formItem.cate_id">
                <Option v-for="(cate, index) in cateList" :key="index" :value="cate.id">{{cate.name}}</Option>
            </Select>
        </FormItem>
          <FormItem label="问题">
              <Input v-model="formItem.question" placeholder="请输入问题"></Input>
          </FormItem>
          <FormItem label="回答">
            
            <EditorTool toref="knowEditor" ref="answerAddElem"></EditorTool>

        </FormItem>
        </Form>
    </Modal>
    <Modal 
        v-model="editModal"
        title="编辑"
        width="500"
        @on-ok="editKnowledge()"
        >
        <Form :model="editFormItem" :label-width="80">
          <FormItem label="分类">
            <Select v-model="editFormItem.cate_id">
                <Option v-for="(cate, index) in cateList" :key="index" :value="cate.id">{{cate.name}}</Option>
            </Select>
        </FormItem>
          <FormItem label="问题">
              <Input v-model="editFormItem.question" placeholder="请输入问题"></Input>
          </FormItem>
          <FormItem label="回答">
            <EditorTool :content="editFormItem.answer" toref="knowEditEditor" ref="answerEditorElem"></EditorTool>
            
        </FormItem>
        </Form>
    </Modal>
    <Modal 
        v-model="addCateModal"
        title="添加分类"
        width="500"
        @on-ok="addCate()"
        >
        <Form :model="formItem" :label-width="80">
          <FormItem label="分类">
              <Input v-model="formItem.cateName" placeholder="请输入分类名"></Input>
          </FormItem>
        </Form>
    </Modal>
    <Modal 
        v-model="editCateModal"
        title="编辑分类"
        width="500"
        @on-ok="editCateRequest()"
        >
        <Form :model="editCateFormItem" :label-width="80">
          <FormItem label="分类">
              <Input v-model="editCateFormItem.cateName" placeholder="请输入分类名"></Input>
          </FormItem>
        </Form>
    </Modal>
    <Modal 
        v-model="addLangModal"
        title="添加语言"
        width="500"
        @on-ok="addCate()"
        >
        <Form :model="formItem" :label-width="80">
          <FormItem label="名称">
              <Input v-model="formItem.cateName" placeholder="请输入名称"></Input>
          </FormItem>
        </Form>
    </Modal>
    <Modal 
        v-model="recordModal"
        title="问题添加记录"
        width="800"
        :footer-hide="true"
        >
        <Addrecord></Addrecord>
    </Modal>
  </div>
</template>
<script>
import conf from "@/views/im/conf";
import RequestUtils from "@/utils/RequestUtils";
import Addrecord from "./components/addrecord.vue";
import EditorTool from '@/views/components/editor-tool';
import EventBus from "@/utils/eventBus";

export default {
  name: "faces",
  components: {
    Addrecord,
    EditorTool
  },
  props: {
      //内容
      value: {
          type: String,
          default: ''
      },
      //是否禁用
      disabled: {
          type: Boolean,
          default: false
      },
      triggerChange: {
          type: Boolean,
          default: false,
          required: false
      },
      //插件
      plugins: {
          type: [String, Array],
          default: () => ['link', 'preview', 'paste']
      }
  },
  data() {
    return {
      langList: [],
      cateList: [],
      qaList: [],
      pageParam: {},
      activeCate: {},
      keyword: '',
      cateKeyword: '',
      load: 1,
      addModal: false,
      editModal: false,
      editCateModal: false,
      addCateModal: false,
      recordModal: false,
      addLangModal: false,
      scrollHeight: '500',
      tableHeight: '500',
      country: 0,
      formItem: {
        question: '',
        answer: '',
        cateName: ''
      },
      editFormItem: {
        question: '',
        answer: '',
        cate_id: ''
      },
      editCateFormItem: {
        cateName: ''
      },
      editorOption: {},
      total: 0,
      curPage: 1,
      pageSize: 20,
      columns: [
          {
              title: '标准问法/常用语',
              slot: 'questions',
          },
          {
              title: '答案/内容',
              slot: 'answers',
          },
          // {
          //     title: '分类',
          //     slot: 'cate',
          //     maxWidth: 250
          // },
          {
              title: '修改用户',
              slot: 'user',
              maxWidth: 250
          },
          {
              title: '创建时间',
              key: 'create_time_text',
          },
          {
              title: '操作',
              slot: 'action',
              width: 350,
              align: 'center'
          }
          
      ],
      data: [ 
      ]

    };
  },
  methods: {
    onEditorBlur(){// 失去焦点事件
    }, 
    onEditorFocus(){// 获得焦点事件
    }, 
    onEditorChange(){// 内容改变事件
    },
    showFace: function (index) {
      this.faceList = this.faceTab[index].chilrens;
    },
    hoverCate: function (index) {
      this.cateList[index].show = true;
    },
    hoveroutCate: function(index) {
      this.cateList[index].show = false;
    },
    tabEvent: function (country) {
      this.country = country;
      this.getKnowCate();
    },
    switchPage (index) {
      this.curPage = index;
      this.getQaList();
    },
    switchPagesize (size) {
      this.pageSize = size;
      this.curPage = 1;
      this.getQaList();
    },
    // 获取语言
    getLangs: function () {
      let self = this;
      let param = new FormData();

      RequestUtils.request(conf.getKnowLang(), param).then(json => {
        self.langList = json;
        this.country = json[0].country;
        this.getKnowCate();
      })
    },
    // 获取分类
    getKnowCate: function () {
      let self = this;
      let param = new FormData();
      let country = this.country ? this.country : this.langList[0].country;
      param.set("keyword", this.cateKeyword);
      param.set("country", country);
      this.cateList = [];
      this.data = [];
   
      RequestUtils.request(conf.getKnowCate(), param).then(json => {
        for (let i=0; i<json.length; i++) {
          json[i].show = false;
        }
        self.cateList = json;
        self.selectCate(null);
      })
    },
    selectCate: function (item) {
      this.keyword = '';
      this.activeCate = item;
      this.curPage = 1;
      this.getQaList();
    },
    getMore: function () {
      this.getQaList(this.pageParam.current_page+1);
    },
    getQaList: function () {
      
      let param = new FormData();
      if (this.activeCate) {      
        param.set("cate_id", this.activeCate.id);
      }
      let country = this.country ? this.country : this.langList[0].country;
      param.set("country", country);
      param.set("keyword", this.keyword);
      param.set("page", this.curPage);

      // this.data = [];
      this.load = 2;
      RequestUtils.request(conf.getKnowQa(), param).then(json => {
        for (let i=0; i<json.data.length; i++) 
        {
          json.data[i].textspread = false;
        }
        this.total = json.total;
        this.data = json.data;
        setTimeout(() => function () {
          this.$previewRefresh(); // 预览图片刷新
        }, 1000)
      })
    },
    onCopy(item) {
      this.$copyText(item.answers).then(() => {
        this.$Message.success('已成功复制到剪切板');
      }).catch(() => {
        this.$Message.error('复制失败');
      })
    },
    copyToChat(item) {
      EventBus.$emit('copyToChat', item.answers_short);
    },
    addKnowledge() {
      let self = this;
      let param = new FormData();
      let content = this.$refs.answerAddElem.getEditorContent();
      let country = this.country ? this.country : this.langList[0].country;
      param.set("cate_id", this.formItem.cate_id);
      param.set("questions", this.formItem.question);
      param.set("answers", content);
      param.set("country", country);

      if (!this.formItem.question) {
        return this.$Message.error('请输入问题');
      }

      RequestUtils.request(conf.addKnowledge(), param).then(() => {
        self.formItem.question = '';
        this.$refs.answerAddElem.clearContent();
        
        self.$Message.success('添加成功');
        self.getQaList();
      });
    },
    editKnowledge() {
      let self = this;
      let param = new FormData();
      let content = this.$refs.answerEditorElem.getEditorContent();
      param.set("id", this.editFormItem.id);
      param.set("questions", this.editFormItem.question);
      param.set("answers", content);

      if (!this.editFormItem.question) {
        return this.$Message.error('请输入问题');
      }

      RequestUtils.request(conf.editKnowledge(), param).then(() => {        
        self.$Message.success('修改成功');
        self.getQaList();
      });
    },
    editKnow: function (item) {
      this.editModal = true;
      this.editFormItem = {
        id: item.id,
        question: item.questions,
        answer: item.answers,
        cate_id: item.cate_id
      }
    },
    topUp: function (item) {
      let self = this;
      let param = new FormData();
      param.set("id", item.id);
      console.log(item);
      if (item.weigh > 0) {
        param.set("weight", 0);
      } else {
        param.set("weight", 999);
      }
      RequestUtils.request(conf.topUpKnowledge(), param).then(() => {
        self.getQaList();
      });
    },
    delKnow: function (item) {
      let self = this;
      this.$Modal.confirm({
          title: '提示',
          content: '<p>確定要刪除吗?</p>',
          onOk: () => {
            let param = new FormData();
            param.set("id", item.id);
            RequestUtils.request(conf.delKnowledge(), param).then(() => {
              
              self.$Message.success('删除成功');
              self.getQaList();
            });
          },
          onCancel: () => {
          }
      });
    },
    addCate() {
      let self = this;
      let param = new FormData();
      let country = this.country ? this.country : this.langList[0].country;
      param.set("cateName", this.formItem.cateName);
      param.set("country", country);

      if (!this.formItem.cateName) {
        return this.$Message.error('请输入分类名');
      }

      RequestUtils.request(conf.addKnowledgeCate(), param).then(() => {
        self.formItem.cateName = '';
        
        self.$Message.success('添加成功');
        self.getKnowCate();
      });
    },
    editCate: function (item) {
      this.editCateModal = true;
      this.editCateFormItem = {
        id: item.id,
        cateName: item.name
      }
    },
    editCateRequest: function () {
      let self = this;
      let param = new FormData();
      param.set("id", this.editCateFormItem.id);
      param.set("cateName", this.editCateFormItem.cateName);

      if (!this.editCateFormItem.cateName) {
        return this.$Message.error('请输入分类名');
      }

      RequestUtils.request(conf.editCate(), param).then(() => {        
        self.$Message.success('修改成功');
        self.getKnowCate();
      });
    },
    delCate: function (item) {
      let self = this;
      this.$Modal.confirm({
          title: '提示',
          content: '<p>確定要刪除吗?</p>',
          onOk: () => {
            let param = new FormData();
            param.set("id", item.id);
            RequestUtils.request(conf.delCate(), param).then(() => {
              
              self.$Message.success('删除成功');
              self.getKnowCate();
            });
          },
          onCancel: () => {
          }
      });
    }
  },
  mounted: function() {
    this.scrollHeight = document.querySelector('body').offsetHeight - 90 - 90;
    this.tableHeight = this.scrollHeight - 90;
    console.log(this.scrollHeight);
    this.getLangs();
  }
  
};
</script>

<style scoped lang="scss">
  .knowledge-wrap {

    .ivu-layout-header {
      background: #f5f7f9;
      display: flex;
      align-items: center;
    }

    .add-btn {
      width: 90%;
      border:1px dashed #999;
      border-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px;
      background: #fff;
      cursor: pointer;
      margin: 0px auto;
    }

    .cate-tool {
      position: absolute;
      top: 12px;
      right: 5px;
    }

    .qa-wrap {
      display: flex;
      flex-direction: column;

      .label-wrap {
        font-weight: bold;
      }
      .question-val {
        color: #3c8dbc;
      }
      .knowledge-img-wrap {
        margin: 0px 5px;      
        .knowledge-img {
          max-width: 50px;
        }
      }

      .tools {
        position: absolute;
        right: 0px;
        .editor-tool {

        }
        .copy-tool {
          padding-left: 10px;
        }
      }
    }
  }
</style>
